import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
export function TrustStrip() {
  const companies = ['AMEX', 'CATERPILLAR', 'DROPBOX', 'BLUECROSS BLUE SHIELD', 'PwC', 'AON'];
  return <section className="py-14 border-y border-border/50 bg-surface/30" data-id="element-248">
      <div className="container mx-auto px-6 md:px-12" data-id="element-249">
        <SectionReveal data-id="element-250">
          <p className="text-center text-sm text-muted mb-10 uppercase tracking-widest font-medium" data-id="element-251">
            Worked with engineering teams at
          </p>
          <div className="flex flex-wrap justify-center items-center gap-x-12 md:gap-x-16 gap-y-8" data-id="element-252">
            {companies.map((company, i) => <span key={i} className="font-serif text-xl md:text-2xl font-semibold tracking-tight text-secondary/70 grayscale hover:text-primary hover:scale-105 transition-all duration-300 cursor-default" data-id="element-253">
                {company}
              </span>)}
          </div>
        </SectionReveal>
      </div>
    </section>;
}